import React, { useEffect, useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import './dialog-pix.css'
import { InputText } from "primereact/inputtext";
import pixService from "../../../services/pix/pixService";
import { showMessageError } from "../../others/toastr";
import { ProgressSpinner } from "primereact/progressspinner";
import { AiOutlineCopy, AiOutlineMail } from "react-icons/ai"
import { RiMailCheckLine } from "react-icons/ri"
import { Messages } from 'primereact/messages';
import { somaValorTotalParcelas, makeParcelasString, makeParcelasStringPontoVirgula } from '../../../modulos/mensalidade/utilsBoletoAdyen'
import moment from "moment";
import mensalidadeService from "../../../services/mensalidades/mensalidadeService";
import * as yup from "yup";

export default function DialogPix({ open, setOpen, header, setMetodoPagamento, inscricao, faturas }) {

  const [qrPix, setQrPix] = useState(null)
  const [pixCopia, setPixCopia] = useState(null)
  const [loading, setLoading] = useState(true)
  const [parcelas, setParcelas] = useState(true)
  const [valor, setValor] = useState(0)
  const [email, setEmail] = useState('mail@mail.com')
  const [envioEmail, setEnvioEmail] = useState(false)
  const [emailEnviado, setEmailEnviado] = useState(false)
  const [loadEnviarEmail, setLoadEnviarEmail] = useState(false)
  const [associado, setAssociado] = useState(null)

  let messages = useRef(null);


  useEffect(() => {

    const generatePix = async () => {
      try {
        setLoading(true)
        const valorFaturas = somaValorTotalParcelas(faturas)
        setValor(valorFaturas)
        const body = await makeBodyFaturas(faturas, valorFaturas)
        const pix = await pixService.geraPixMensalidades(inscricao, body)
        setQrPix(pix.image)
        setPixCopia(pix.code)
        setLoading(false)
      } catch (err) {
        showMessageError('Erro', 'Erro ao gerar Pix')
        setTimeout(() => {
          setOpen(false)
        }, 2000)
      }
    }


    const makeParcelas = () => {
      const stringParcelas = makeParcelasString(faturas)
      setParcelas(stringParcelas)
    }

    const loadAssociado = async () => {
      const associado = await mensalidadeService.buscaAssociadoPorInscricao(inscricao)
      setEmail(associado.AssEmail)
    }

    if (open) {
      setEnvioEmail(false)
      setEmailEnviado(false)
      setLoadEnviarEmail(false)
      generatePix()
      makeParcelas()
      loadAssociado()
    }

  }, [open])

  const enviarEmail = async () => {
    try {
      setLoadEnviarEmail(true)
      if (!(await isEmailValido(email)) || email === null || email === '') {
        messages.current.show({ severity: 'warn', summary: 'Email inválido', detail: 'Digite um email válido' });
        setLoadEnviarEmail(false)
        return
      }
      const bodyEnvioPix = makeBodyPixEmail(associado)
      await mensalidadeService.envioPixEmail(bodyEnvioPix)
      setLoadEnviarEmail(false)
      setEmailEnviado(true)
    } catch (err) {
      messages.current.show({ severity: 'error', summary: 'Erro', detail: 'Houve um erro ao enviar seu email!' });
      resetarEmail()
    }

  }

  const makeBodyPixEmail = () => {
    return {
      email,
      copiaColaPix: pixCopia,
      imagem: qrPix,
      valor,
      faturas: parcelas
    }
  }

  const resetarEmail = () => {
    setEmailEnviado(false)
    setLoadEnviarEmail(false)
  }

  const isEmailValido = async () => {
    const schema = yup.object().shape({
      email: yup.string().email()
    })
    return await schema.isValid({ email })
  }

  const makeBodyFaturas = async (faturas, valor) => {
    const parcelas = {
      Referencia: makeParcelasStringPontoVirgula(faturas),
      Valor: +valor,
      Vencimento: moment().add(3, 'd').format('YYYY-MM-DD')
    }

    return { parcelas: [parcelas] }

  }

  const close = () => {
    setMetodoPagamento(null)
    setOpen(false)
  }

  const copiar = () => {
    navigator.clipboard.writeText(pixCopia)
    messages.current.show({ severity: 'success', summary: 'Sucesso', detail: 'copiado com sucesso!' });
  };

  return (
    <Dialog visible={open} style={{ width: '70vw', marginTop: '40px', transition: '.4s ease-in-out' }} onHide={close} position={'top'} header={header}>
      {!loading ? (
        <>
          <Messages ref={messages} style={{ margin: '0 20px' }} />
          <div className="page-pix">
            <div className="content-cobranca">
              <h1>Cobrança</h1>
              <h2>Valor: R${valor.replace('.', ',')}</h2>
              <h2>Faturas: {parcelas}</h2>
            </div>
            <div className="separacao-dialog-pix"></div>
            <div className="content-pix">
              <div className="Qrcode-pix">
                <h1>Pagamento com PIX</h1>
                <img src={qrPix} />
              </div>
              <div className="copia-e-cola">
                <InputText disabled value={pixCopia} style={{ width: '60%', margin: '15px 0', cursor: 'text' }} />
                <button onClick={copiar}>
                  <AiOutlineCopy color="white" size={20} />
                  <span style={{ marginLeft: '5px' }}>Copiar</span>
                </button>
              </div>
              {envioEmail && (
                <div className="envio-email">
                  <InputText value={email} onChange={e => setEmail(e.target.value)} style={{ width: '60%', margin: '15px 0', cursor: 'text' }} disabled={emailEnviado || loadEnviarEmail} />
                  {!emailEnviado ? (
                    <button onClick={enviarEmail} disabled={loadEnviarEmail}>
                      {
                        !loadEnviarEmail ?
                          (
                            <>
                              <AiOutlineMail color="white" size={20} />
                              <span style={{ marginLeft: '5px' }}>Enviar por email</span>
                            </>
                          ) : (

                            <div className="progress-email">
                              <ProgressSpinner style={{ width: '20px', heigth: '20px', margin: '0', padding: '0' }} />
                              <span style={{ marginLeft: '5px' }}>Enviando...</span>
                            </div>
                          )
                      }
                    </button>
                  ) :
                    <button style={{ backgroundColor: 'rgb(52, 219, 108)', cursor: 'default' }}>
                      <RiMailCheckLine color="white" size={20} />
                      <span style={{ marginLeft: '5px' }}>Email Enviado</span>
                    </button>}
                </div>
              )}
              {!envioEmail &&
                <a className="enviar-email-link" onClick={() => setEnvioEmail(true)}>Enviar por email</a>
              }
              {emailEnviado &&
                <a className="enviar-email-link" onClick={resetarEmail}>Enviar outro email</a>
              }
            </div>
          </div>
        </>
      ) :

        <div className="spinner-pix">
          <ProgressSpinner />
        </div>
      }
    </Dialog>
  )
}